import Avvir from "avvir";
import { AvvirAsyncThunk } from "../make_eventful_action";
import tosLoaded, { LATEST_TOS_LOADED } from "../../events/loaded/latest_tos_loaded";
import getLatestTos from "../../services/getters/get_latest_tos";
import { Action } from "redux";

type DispatchedEvents = Action<typeof LATEST_TOS_LOADED>;

const loadLatestTos = (): AvvirAsyncThunk<typeof getLatestTos, DispatchedEvents> => {
  return (dispatch, getState) => {
    const user = getState().user;
    return Avvir.api.tos.getLatest(user).then((latestTos) => {
      dispatch(tosLoaded(latestTos));
      return getLatestTos(getState(), {});
    });
  };
};

export default loadLatestTos;
